import React, { useEffect, useState } from "react";
import { Stack, Grid, Flex, Text, Group } from "@mantine/core";

const CXGenieBot: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widget.cxgenie.ai/widget.js";
    script.setAttribute("data-aid", "ea9afb04-ad17-4f3e-ba4a-f2ac56831663");
    script.setAttribute("data-lang", "en");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <Flex className="w-full h-full flex flex-col justify-center items-center">
      <div className="flex flex-col h-screen w-full bg-black justify-center items-center"></div>
    </Flex>
  );
};

export default CXGenieBot;
